import { Vue, Component } from 'vue-property-decorator';
import { Grid } from '@samc/centricity-core';
import { ReportExecutionDataSource } from './DataSource/ReportExecutionLogDataSource';
import { IReportExecutionLog } from './Interfaces/IReportExecutionLog';

import '@/registerVuePlugins';

@Component({
  components: { Grid }
})
class ExecutionLogCompoent extends Vue {
  public reportExecutionLogKey: number = 1;
  public dataSource: ReportExecutionDataSource | null = null;
  public statusDataSource: ({ text: string })[] = [
    { text: 'InProgress' }, { text: 'Failed' }, { text: 'FailedSchedule' }, { text: 'FailedLoadReport' }, { text: 'FailedExecution' }, { text: 'FailedFileCreation' },
    { text: 'FailedAttachment' }, { text: 'FailedDelivery' }, { text: 'Done' }
  ];

  public verificationToken: string = '';

  public async mounted() {
    this.verificationToken = await this.$verificationToken();
    const url = (this.$refs['queryBuilderUrl'] as HTMLInputElement).value;
    this.dataSource = new ReportExecutionDataSource(url, this.verificationToken);
  }
}

new ExecutionLogCompoent()
  .$mount('#report-execution-log');